var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c(
        "v-layout",
        {
          staticStyle: { height: "100%", "background-color": "#222" },
          attrs: { row: "", wrap: "", "justify-center": "" }
        },
        [
          _c(
            "v-flex",
            {
              staticStyle: {
                width: "3.5%",
                "background-color": "#1d1d1d",
                height: "100%"
              }
            },
            [
              _c("left-panel", {
                attrs: {
                  activeTab: _vm.active,
                  model: _vm.model,
                  editor: _vm.editor,
                  logicNodeType: _vm.logicNodeType,
                  removeAnimation: _vm.removeAnimation,
                  selectedAnimation: _vm.selectedAnimation,
                  diagram: _vm.diagram,
                  diagramData: _vm.diagramData,
                  currentNode: _vm.currentNode,
                  saveTimeline: _vm.saveTimeline,
                  getTimelineById: _vm.getTimelineById,
                  worldScaleFactor: _vm.worldScaleFactor
                },
                on: { updateTimelineId: _vm.changeTimelineId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.savedChanges
            ? _c(
                "v-flex",
                {
                  staticStyle: {
                    position: "absolute",
                    "z-index": "11",
                    right: "320px",
                    top: "-30px"
                  },
                  attrs: { xs2: "", "offset-3": "" }
                },
                [
                  _c("span", { staticStyle: { color: "#e6ede7" } }, [
                    _vm._v("Your changes are saved")
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticStyle: { width: "79%" } },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c(
                    "v-flex",
                    { staticStyle: { width: "100%" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "fill-height": "",
                            "justify-center": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { ref: "tab", staticStyle: { width: "100%" } },
                            [
                              _c(
                                "v-tabs",
                                {
                                  attrs: {
                                    color: "#1d1d1d",
                                    dark: "",
                                    "slider-color": "#c95b6e"
                                  },
                                  model: {
                                    value: _vm.active,
                                    callback: function($$v) {
                                      _vm.active = $$v
                                    },
                                    expression: "active"
                                  }
                                },
                                [
                                  _vm._l(_vm.tabs, function(tab) {
                                    return _c(
                                      "v-tab",
                                      { key: tab.title, attrs: { ripple: "" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(tab.title) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("conversation", {
                                    attrs: {
                                      diagramData: _vm.diagramData,
                                      getTimelineById: _vm.getTimelineById,
                                      editor: _vm.editor,
                                      storyID: _vm.storyID,
                                      diagram: _vm.diagram
                                    },
                                    on: { deSelectTheNode: _vm.deSelectTheNode }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { staticStyle: { "max-width": "10%" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "Scale Factor" },
                                        model: {
                                          value: _vm.worldScaleFactor,
                                          callback: function($$v) {
                                            _vm.worldScaleFactor = $$v
                                          },
                                          expression: "worldScaleFactor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.timelineId &&
                                            this.currentNode &&
                                            this.currentNode.data.category ===
                                              "Scene",
                                          expression:
                                            "timelineId && this.currentNode && this.currentNode.data.category === 'Scene'"
                                        }
                                      ],
                                      attrs: { ripple: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Preview\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c("vue-progress-bar"),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "", row: "" } },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                height: "100%",
                                                "background-color": "#222"
                                              },
                                              attrs: {
                                                row: "",
                                                wrap: "",
                                                "justify-center": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.active === 0,
                                                      expression: "active === 0"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _c("gojs-tree", {
                                                    ref: "diag",
                                                    staticClass:
                                                      "timelineBorderRadius",
                                                    style: {
                                                      height: _vm.tabHeight
                                                    },
                                                    attrs: {
                                                      xs12: "",
                                                      currentNode:
                                                        _vm.currentNode,
                                                      "model-data":
                                                        _vm.diagramData
                                                    },
                                                    on: {
                                                      "model-changed":
                                                        _vm.modelChanged,
                                                      "changed-selection":
                                                        _vm.changedSelection,
                                                      "selection-deleted":
                                                        _vm.selectionDeleted,
                                                      "paste-selection":
                                                        _vm.pasteSelection,
                                                      "selection-deleting":
                                                        _vm.selectionDeleting
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              style: { height: _vm.tabHeight }
                                            },
                                            [_vm._v(" Universals Rules")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              style: { height: _vm.tabHeight }
                                            },
                                            [_vm._v("Live Rules")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            [
                                              _vm.active === 3 && _vm.timelineId
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c("preview", {
                                                        style: {
                                                          height: _vm.tabHeight
                                                        },
                                                        attrs: {
                                                          animationSelected:
                                                            _vm.selectedAnimation,
                                                          selectedTimeline:
                                                            _vm.selectedTimeline,
                                                          currentNode:
                                                            _vm.currentNode,
                                                          editor: _vm.editor
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.timelineId,
                                expression: "timelineId"
                              }
                            ],
                            attrs: { id: "controls-div" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.timelineId,
                        expression: "timelineId"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { id: "timeline-div" }
                  }),
                  _vm._v(" "),
                  _vm.currentNode && _vm.currentNode.data.category !== "Scene"
                    ? _c("bottomPanel", {
                        attrs: {
                          category: _vm.currentNode.data.category,
                          currentNode: _vm.currentNode,
                          editor: _vm.editor,
                          diagramData: _vm.diagramData
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", {
            staticStyle: { width: "17.5%" },
            style: {
              height: _vm.sidebarHeight + "px",
              "max-height": _vm.sidebarHeight + "px"
            },
            attrs: { id: "right-sidebar" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "400" },
              model: {
                value: _vm.showChatDialog,
                callback: function($$v) {
                  _vm.showChatDialog = $$v
                },
                expression: "showChatDialog"
              }
            },
            [
              _c(
                "v-card",
                {
                  staticStyle: { width: "400px", padding: "20px" },
                  attrs: { id: "talkMitsuku" }
                },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "headline",
                      staticStyle: { padding: "20px 0 10px 30px" }
                    },
                    [_vm._v("Talk to Mitsuku")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticStyle: { width: "300px", "margin-left": "30px" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Type message here" },
                        model: {
                          value: _vm.message,
                          callback: function($$v) {
                            _vm.message = $$v
                          },
                          expression: "message"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.responsesFromMitsuku, function(res, index) {
                    return _c(
                      "v-flex",
                      {
                        key: index,
                        staticStyle: { padding: "10px", "margin-left": "20px" }
                      },
                      [
                        _c(
                          "span",
                          { staticStyle: { "font-size": "14px" } },
                          [
                            _c(
                              "strong",
                              { staticStyle: { color: "#F06292" } },
                              [
                                _vm._v(
                                  "Mitsuku Response " + _vm._s(index + 1) + " "
                                )
                              ]
                            ),
                            _vm._v(' "' + _vm._s(res) + '" '),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0",
                                attrs: { text: "", icon: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.copyMitsukuResponse(index)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticStyle: {
                                      "vertical-align": "baseline",
                                      "font-size": "14px",
                                      color: "#3d3d3d"
                                    }
                                  },
                                  [_vm._v("fas fa-copy")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", id: index },
                          domProps: { value: res }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.showChatDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", flat: "" },
                          on: { click: _vm.talkToMitsuku }
                        },
                        [_vm._v("Talk")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "400" },
              model: {
                value: _vm.showSynonymDialog,
                callback: function($$v) {
                  _vm.showSynonymDialog = $$v
                },
                expression: "showSynonymDialog"
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pl-4",
                  staticStyle: { width: "400px", "background-color": "#fff" },
                  attrs: { wrap: "", id: "synonyms" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        position: "absolute",
                        right: "15px",
                        top: "25px"
                      },
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          _vm.showSynonymDialog = false
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "grey" } }, [
                        _vm._v("close")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-title",
                    {
                      staticClass: "pt-5",
                      staticStyle: {
                        color: "#303030",
                        "font-size": "20px",
                        "text-transform": "uppercase",
                        "font-weight": "500"
                      },
                      attrs: { dark: "" }
                    },
                    [_vm._v("Synonyms")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.synonymsArray, function(res, index) {
                    return _c(
                      "v-flex",
                      {
                        key: index,
                        staticClass: "pl-3 my-1",
                        attrs: { "fill-height": "", xs12: "" }
                      },
                      [
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "pt-2 mt-1",
                                attrs: { xs12: "", sm8: "" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "14px",
                                      "vertical-align": "middle"
                                    }
                                  },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        staticStyle: {
                                          color: "#bf975f",
                                          "font-size": "16px",
                                          "font-weight": "500"
                                        }
                                      },
                                      [_vm._v("Synonym #" + _vm._s(index + 1))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "ml-2",
                                        staticStyle: {
                                          color: "#303030",
                                          "font-size": "15px",
                                          "text-transform": "uppercase"
                                        }
                                      },
                                      [_vm._v(_vm._s(res))]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "pa-auto",
                                attrs: { xs12: "", sm4: "" }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticStyle: {
                                      "text-transform": "none",
                                      "vertical-align": "middle",
                                      "font-size": "15px"
                                    },
                                    attrs: {
                                      text: "",
                                      dark: "",
                                      round: "",
                                      flat: "",
                                      outline: "",
                                      color: "#bf975f"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.dispatchToUserTab(index)
                                      }
                                    }
                                  },
                                  [_vm._v("add")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.showSynonymDialog = false
                            }
                          }
                        },
                        [_vm._v("Done")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14a6561a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a6561a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/StoryEditView.vue
// module id = null
// module chunks = 